import { defineComponent as _defineComponent } from 'vue'
import {computed, ref, watch} from "vue";

type CollapsableCardProps = {
  cardTitle: string;
  cardSubtitle?: string;
  customStyle?: string | Record<string, string | number>;
  expanded?: boolean;
  stepLabel?: string;
  status?: StepStatus;
}

type StepStatus = "default" | "error" | "success" | "warning";


export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsableCard',
  props: {
    cardTitle: { default: '' },
    cardSubtitle: { default: '' },
    customStyle: { default: '' },
    expanded: { type: Boolean, default: false },
    stepLabel: { default: '' },
    status: { default: 'default' }
  },
  setup(__props: any) {

const props = __props as { cardTitle: string, cardSubtitle: string, customStyle: string | Record<string, string | number>, expanded: boolean, stepLabel: string, status: StepStatus };



const badgeClass = computed(() => {
  return {
    "step-label": true,
    "step-label-error": props.status === "error",
    "step-label-warning": props.status === "warning"
  };
});

const isExpanded = ref(props.expanded);
const computedStyle = computed(() => {
  if (typeof props.customStyle === 'string') {
    return props.customStyle;
  }
  return { ...props.customStyle };
});

watch(
  () => props.expanded,
  (val) => {
    isExpanded.value = val;
  }
);

function expandAccordion() {
  isExpanded.value = !isExpanded.value;
}

return { __sfc: true,props, badgeClass, isExpanded, computedStyle, expandAccordion }
}

})